/**
 * @generated SignedSource<<4fa78f633a1805c0ad556ca9c495b731>>
 * @relayHash 326f816a479efbb2e38411608a545d94
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5b9f03434087a6ab17e0294f730963f4c169856922ad2a925eb06a34a1fd4c5f

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ImageContentType = "GIF" | "JPEG" | "PNG" | "WEBP" | "%future added value";
export type ImageOwnerType = "EVENTS" | "GUILDS" | "GUILD_NETWORKS" | "GUILD_SPONSORSHIPS" | "POSTS" | "USERS" | "VENUES" | "%future added value";
export type CreateImageInput = {
  contentType: ImageContentType;
  height?: number | null | undefined;
  ownerId: string;
  ownerType: ImageOwnerType;
  width?: number | null | undefined;
};
export type FormImageUploadMutation$variables = {
  input: CreateImageInput;
};
export type FormImageUploadMutation$data = {
  readonly createImage: {
    readonly image: {
      readonly markdownUrl: string;
      readonly rowId: string;
      readonly url: string;
    } | null | undefined;
    readonly uploadURL: string | null | undefined;
  };
};
export type FormImageUploadMutation = {
  response: FormImageUploadMutation$data;
  variables: FormImageUploadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v4 = {
  "alias": "markdownUrl",
  "args": [
    {
      "kind": "Literal",
      "name": "transform",
      "value": {
        "fit": "scale-down",
        "w": 400
      }
    }
  ],
  "kind": "ScalarField",
  "name": "transformUrl",
  "storageKey": "transformUrl(transform:{\"fit\":\"scale-down\",\"w\":400})"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uploadURL",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FormImageUploadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateImagePayload",
        "kind": "LinkedField",
        "name": "createImage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FormImageUploadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateImagePayload",
        "kind": "LinkedField",
        "name": "createImage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "5b9f03434087a6ab17e0294f730963f4c169856922ad2a925eb06a34a1fd4c5f",
    "metadata": {},
    "name": "FormImageUploadMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7176813eebeadd9e572d2e620bc56fb9";

export default node;
